module.exports = __webpack_public_path__ + "static/media/woodsman.daba77f2.png";